import turfDifference from "@turf/difference";
import { featureCollection } from '@turf/helpers';

export default function difference(feature1, feature2) {
    //create a collection of the two features
    // var collection = featureCollection([feature1,feature2]);

    return turfDifference(feature1, feature2);
};
